// extracted by mini-css-extract-plugin
export default {"authCallbackContainer":"AuthCallback_authCallbackContainer__EOszm","authCallbackBox":"AuthCallback_authCallbackBox__hE749","loadingText":"AuthCallback_loadingText__sNiax"};